import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import en from './locales/en.json' with { type: 'json' };
import ne from './locales/ne.json' with { type: 'json' };
const DICTIONARIES = { en, ne };
const LocaleContext = React.createContext(undefined);
function interpolate(template, vars) {
    if (!vars)
        return template;
    return template.replace(/\{(\w+)\}/g, (match, name) => {
        const value = vars[name];
        return value === undefined ? match : String(value);
    });
}
/**
 * Sets `<html lang>` (§7.7 — assistive tech pronunciation rules depend on it) whenever
 * the locale changes. Consuming apps should mount exactly one `LocaleProvider` at the
 * root of the tree; the gallery mounts its own for the same reason a real app would.
 */
export function LocaleProvider({ children, locale: controlledLocale, defaultLocale = 'en', onLocaleChange, }) {
    const [uncontrolledLocale, setUncontrolledLocale] = React.useState(defaultLocale);
    const locale = controlledLocale ?? uncontrolledLocale;
    React.useEffect(() => {
        if (typeof document !== 'undefined') {
            document.documentElement.lang = locale;
        }
    }, [locale]);
    const setLocale = React.useCallback((next) => {
        setUncontrolledLocale(next);
        onLocaleChange?.(next);
    }, [onLocaleChange]);
    const t = React.useCallback((key, vars) => {
        const dictionary = DICTIONARIES[locale];
        const template = dictionary[key] ?? DICTIONARIES.en[key] ?? key;
        return interpolate(template, vars);
    }, [locale]);
    const value = React.useMemo(() => ({ locale, setLocale, t }), [locale, setLocale, t]);
    return _jsx(LocaleContext.Provider, { value: value, children: children });
}
export function useLocale() {
    const context = React.useContext(LocaleContext);
    if (!context) {
        throw new Error('useLocale must be used within a <LocaleProvider>. Mount one at the app root.');
    }
    return context;
}
//# sourceMappingURL=locale-context.js.map